var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfume2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7115 1.76279C20.8425 2.15575 20.6301 2.58049 20.2372 2.71147L17.2372 3.71147C16.8442 3.84246 16.4195 3.63009 16.2885 3.23713C16.1575 2.84417 16.3699 2.41943 16.7628 2.28845L19.7628 1.28845C20.1558 1.15746 20.5805 1.36983 20.7115 1.76279Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.99996C10 2.44767 10.4477 1.99996 11 1.99996H13C13.5523 1.99996 14 2.44767 14 2.99996C13.4477 2.99996 13 3.44772 13 4C13 4.55228 13.4477 5 14 5V5.47958C17.8687 6.38415 20.75 9.85558 20.75 14C20.75 18.8325 16.8325 22.75 12 22.75C7.16751 22.75 3.25 18.8325 3.25 14C3.25 9.85558 6.13129 6.38415 10 5.47958V2.99996ZM11.25 6.78828C7.59833 7.16358 4.75 10.2491 4.75 14C4.75 18.004 7.99594 21.25 12 21.25C16.0041 21.25 19.25 18.004 19.25 14C19.25 10.2491 16.4017 7.16358 12.75 6.78828V14.3094C14.2143 14.6685 15.7525 14.6421 17.2124 14.225L17.2503 14.2142C17.626 14.1068 18.0002 14.3904 17.95 14.7779C17.5686 17.7241 15.0501 20 12 20C8.81506 20 6.20972 17.5184 6.01205 14.3833C5.99765 14.1549 6.14646 13.9511 6.36359 13.8788C7.94993 13.35 9.6591 13.3341 11.25 13.8279V6.78828Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7115 6.23713C20.8425 5.84417 20.6301 5.41943 20.2372 5.28845L17.2372 4.28845C16.8442 4.15746 16.4195 4.36983 16.2885 4.76279C16.1575 5.15575 16.3699 5.58049 16.7628 5.71147L19.7628 6.71147C20.1558 6.84246 20.5805 6.63009 20.7115 6.23713Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfume2);
export default __webpack_public_path__ + "static/media/perfume-2.a4b57db51230479d0080b831f454f902.svg";
export { ForwardRef as ReactComponent };